import { IconManifest } from 'app/agriculture/icons/types';

interface SymbolProps {
    icon: IconManifest;
    strokeWidth?: number;
}

export function Symbol({ icon, strokeWidth }: SymbolProps) {
    const { d, id, width, height } = icon;

    return `<symbol id="${id}" viewBox="0 0 ${width} ${height}">
              <path d="${d}" stroke-width="${strokeWidth}" />
            </symbol>`;
}
